<template>
  <div class="mt-3">
    <div class="row">
      <div class="col-12">
        <h3>UNITS</h3>
      </div>
    </div>
    <div>
      <!-- CORE UNITS -->
      <draggable :list="value" class="row" @change="changeOrder"> <!-- DRAG -->
        <div class="col-3 card__alternate" v-for="unit in value" :key="unit.id">
          <div class="card" :class="{ 'card__disabled': unit.disabled }">
            <div class="card--feature">
              {{ unit.name | truncate(40) }}
              <span class="badge badge-danger p-1 pl-2 pr-2 float-right ml-1" v-if="!unit.published">
                 DRAFT
              </span>
              <span class="badge badge-info p-1 pl-2 pr-2 float-right">
                  {{ unit.pivot.course_order }}
              </span>
            </div>
            <div class="card--caption">
              <div class="row">
                <div class="col-6">
                  <b>Unit Codes</b>
                </div>
                <div class="col-6">
                <span class="text-red float-right pointer" @click="removeUnit(unit)">
                  <font-awesome-icon icon="times"></font-awesome-icon>
                </span>
                  <router-link :to="'/units/' + unit.id" class="text-blue float-right mr-1 pointer">
                    <font-awesome-icon icon="cog"></font-awesome-icon>
                  </router-link>
                </div>
              </div>
              <div class="row pb-1 pt-1">
                <div class="col-6">
                  {{ unit.codes.map(code => code.name).join(', ') }}
                </div>
                <div class="col-6">
                  <b-form-group class="float-right">
                    <b-form-radio-group
                            id="btn-radios-1"
                            v-model="unit.pivot.type"
                            :options="courseTypes"
                            buttons
                            button-variant="outline-primary"
                            size="sm"
                            name="radios-btn-default"
                    ></b-form-radio-group>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="col-3">
          <div class="card">
            <div class="card--feature card--feature__grey">
              ADD NEW UNIT
            </div>
            <div class="card--caption row pb-1">
              <div class="col">
                <select class="form-control" v-model="selectedUnit">
                  <option :value="0">---</option>
                  <option v-for="unit in units" :value="unit" :key="'select-unit-' + unit.id">
                    {{ unit.name }}
                  </option>
                </select>
              </div>
              <div class="col pt-1">
                <loading-button :loading="loading" class="btn btn-orange btn-block float-right" @submit="addStreamUnit">
                  <b>Add</b>
                </loading-button>
              </div>
            </div>
          </div>
        </div>
      </draggable>
    </div> <!-- /CORE UNITS -->
  </div>
</template>

<script>
import findIndex from 'lodash-es/findIndex'

export default {
  name: 'EditStreamsCards',
  data () {
    return {
      selectedUnit: {
        id: 0
      },
      loading: false,
      courseTypes: [
        {
          value: 1,
          text: 'Core'
        },
        {
          value: 2,
          text: 'Elective'
        },
        {
          value: 3,
          text: 'Sub'
        }
      ]
    }
  },
  computed: {
    units () {
      return this.$store.state.units.filter(unit => {
        return !this.value.map(v => v.id).includes(unit.id)
      })
    }
  },
  methods: {
    changeOrder: function () {
      let units = [...this.value]
      units = units.map((unit, index) => {
        unit.pivot.course_order = index + 1

        return unit
      })

      this.$emit('input', units)

      return true
    },
    removeUnit (unit) {
      let index = findIndex(this.value, { id: unit.id })

      let units = [...this.value]
      units.splice(index, 1)

      this.updateUnits(units).then(() => {
        this.$snotify.success('Unit Removed')
      })
    },
    addStreamUnit () {
      if (!this.selectedUnit.id) { return}

      let units = [...this.value]
      units.push(this.selectedUnit)
      this.loading = true
      this.updateUnits(units).then(() => {
        this.loading = false
        this.$snotify.success('Unit Added')
      })
    },
    updateUnits (units) {
      console.log(units)
      return new Promise((resolve) => {
        units = units.map((unit, index) => {
          unit.pivot = unit.pivot ? unit.pivot : {}
          unit.pivot.course_order = index + 1

          return unit
        })
        this.$emit('input', units)
        this.axios.put('/course_streams/' + this.streamId, { courses: units }).then(rsp => {
          resolve()
        })
      })
    }
  },
  props: {
    value: {
      type: Array
    },
    streamId: {
      type: Number,
      required: true
    }
  }
}
</script>